export default "__VITE_ASSET__ACwqWYtX__$_?assetResource__"